import { DateTime } from 'luxon'

export default function formatDate(date: Date) {
  return DateTime.fromJSDate(date).toFormat('EEE MMM d, h:mm a')
}
